const URL = {
  ENTERATE: 'https://enterate.somosintercorp.net',
  CRECE: 'https://ofertaslaborales.somosintercorp.net',
  BENEFICIATE: 'https://clubintercorp.com/',
  HOME: 'https://somosintercorp.net/',
  ENTRENATE: 'https://entrenate.ucic.pe',
  PORTAL: 'https://portal.ucic.pe/my',
  API: window.location.origin === 'https://entrenate.ucic.pe' ? 'https://produccion-ucic.uc.r.appspot.com' : 'https://testing-ucic.uc.r.appspot.com',
  API_KEY: 'AIzaSyD3Wsj_fWavEDLxQ4urVbuyHtok1Z6SzuM',
  API_PAYMENT: window.location.origin === 'https://entrenate.ucic.pe' ? 'https://sales-course-api-dot-produccion-ucic.uc.r.appspot.com' : 'https://sales-course-api-dot-testing-ucic.uc.r.appspot.com',
  API_COMPLAINT: window.location.origin === 'https://entrenate.ucic.pe' ? 'https://complaint-api-dot-produccion-ucic.uc.r.appspot.com' : 'https://complaint-api-dot-testing-ucic.uc.r.appspot.com',
  // API_COMMUNITIES: 'https://testing-comunidades.ucic.pe/'
  API_COMMUNITIES: 'https://entrenate-comunidades.ucic.pe/'
  // API_COMMUNITIES: 'http://127.0.0.1:8000/'
}

export default URL;
